import developmentConfiguration from './config-dev.json';
import productionConfiguration from './config-prod.json';

const nconf = {
    get: (key) => {
        switch(process.env.NODE_ENV){
            case 'production': {
                return productionConfiguration[key];
            }
            case 'development': 
            default: {
                return developmentConfiguration[key];
            }
        }
    }
}

export default nconf;


// WEBPACK FOOTER //
// ./src/conf/index.js